/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRequest {
    getFixupPrototypeFunction() { return ResourceRequest.fixupPrototype; }

    static newInstance(model: Partial<ResourceRequest>): ResourceRequest {
        let obj = Object.assign(new ResourceRequest(), model);
        ResourceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRequest>): ResourceRequest {
        if (!model) return null;
        return ResourceRequest.newInstance(<ResourceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRequest) {
        if (!obj) return;

        models.ResourceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRequest): boolean {
        Object.setPrototypeOf(obj, ResourceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates whether this template/script will be executed immediately on executing the blueprint or will be scheduled for  one/more occurrences
     */
    execution_type: models.ExecutionType;

    /**
     * A short name that represents the action performed by the template. Useful while viewing the job output while executing the blueprint.
     */
    action: string;

    /**
     * Resource Name
     */
    name: string;

    /**
     * mapping of input parameter for this template to the output parameter of any of the previous templates
     */
    param_mapper: any;

    /**
     * Type for the blueprint
     */
    type: models.BlueprintType;

    /**
     * Object Id of the Template or Script. You can get this from Describe Template/Script call
     */
    id: string;

}
